import React, { Component } from 'react'
import { Carousel } from 'react-bootstrap'

export default class Slider extends Component {
    render() {
        return (
            <Carousel interval={3000}
            >
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/room-oct/1.jpg"
                        alt="Second slide"
                    />


                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/rawabet-jul/2.jpg"
                        alt="First slide"
                    />

                </Carousel.Item>

                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/tap-sep/3.jpg"
                        alt="Third slide"
                    />


                </Carousel.Item>
            </Carousel>
        )
    }
}
